import { postJson } from "./api";

export type NativePairing = {
  pairingId: string;
  userCode: string;
  mode: "signin" | "register";
};

export type NativePairingAuthorizeResponse = {
  status: "authorized";
  account: {
    account_id: string;
    username: string;
    display_name: string;
    passkey_count: number;
    device_count: number;
    push_token_count: number;
  };
};

export function loadNativePairingFromUrl(): NativePairing | null {
  const params = new URLSearchParams(window.location.search);
  const pairingId = params.get("native_pairing_id")?.trim();
  const userCode = params.get("native_user_code")?.trim();
  if (!pairingId || !userCode) {
    return null;
  }

  const requestedMode = params.get("native_mode")?.trim().toLowerCase();
  const mode = requestedMode === "register" ? "register" : "signin";
  return { pairingId, userCode, mode };
}

export function nativePairingPrefill() {
  const params = new URLSearchParams(window.location.search);
  return {
    username: params.get("username")?.trim() ?? "",
    displayName: params.get("display_name")?.trim() ?? "",
  };
}

function bearer(sessionToken: string) {
  return {
    Authorization: `Bearer ${sessionToken}`,
  };
}

export async function authorizeNativePairing(options: {
  sessionToken: string;
  pairingId: string;
  userCode: string;
}): Promise<NativePairingAuthorizeResponse> {
  return postJson<NativePairingAuthorizeResponse>(
    `/v1/account/pairings/${options.pairingId}/authorize`,
    { user_code: options.userCode },
    { headers: bearer(options.sessionToken) },
  );
}

export async function authorizeNativePairingByCode(options: {
  sessionToken: string;
  userCode: string;
}): Promise<NativePairingAuthorizeResponse> {
  return postJson<NativePairingAuthorizeResponse>(
    "/v1/account/pairings/authorize",
    { user_code: options.userCode },
    { headers: bearer(options.sessionToken) },
  );
}
